import { CompanyManagementPermission, UserManagementPermission } from '@auth/permissionsEnum'

/**
 * Permanent Account Manager deletes. Use exact token scopes only.
 * Do not use hasPermission() — resource:all would let IAM/IQM delete today.
 * Grant these scopes on a future super-user role to restore delete.
 */
export function canHardDeleteUsers(tokenPermissions: readonly string[]): boolean {
  return tokenPermissions.includes(UserManagementPermission.HARD_DELETE_USER)
}

export function canHardDeleteCompanies(tokenPermissions: readonly string[]): boolean {
  return tokenPermissions.includes(CompanyManagementPermission.HARD_DELETE_COMPANY)
}
